import { developmentConfig, ENV_CONFIGS_PATH, OA_UI_MODE } from './config.ts';
import { environment } from './environments/environment.ts';

interface EnvironmentConfigs {
  env: string;
  firebase: { storageBucket?: string; apiKey: string; projectId: string; databaseURL?: string; authDomain: string };
}

let environmentConfigsPromise: Promise<EnvironmentConfigs>;

const shouldAllowLocalFallback = OA_UI_MODE !== 'devint';

const fetchEnvironmentConfigs = (): Promise<EnvironmentConfigs> =>
  fetch(ENV_CONFIGS_PATH).then(response => {
    if (!response.ok) {
      throw new Error('Could not fetch environment configs');
    }
    return response.json();
  });

export const initialize = () => {
  if (!environment.production && environment.useLocalConfig) {
    // In CDE/local mode, fallback keeps local startup resilient.
    // In devint mode, require fetched configs to avoid silently using legacy local config.
    environmentConfigsPromise = fetchEnvironmentConfigs().catch(error => {
      if (!shouldAllowLocalFallback) {
        throw error;
      }
      return developmentConfig;
    });
  } else {
    environmentConfigsPromise = fetchEnvironmentConfigs();
  }
};

export const getEnvironmentConfigs = () => {
  if (!environmentConfigsPromise) {
    throw new Error('Environment configs cannot be accessed before initialization');
  }

  return environmentConfigsPromise;
};
